import React from "react";
import { DEV_TOOL_ICONS } from "../data/devToolIcons";

export function iconsToList(icons) {
  return icons ? icons.split(",").filter(Boolean) : [];
}

// Shared by every admin form that stores a comma-separated icon-key list (ServiceCard.icons,
// HeroContent.icons, ...): a clickable grid of an icon set, toggling selection. `icons` defaults to
// the developer-tools set; the Co-Work slides pass the seller-services set instead.
export default function IconPicker({
  selected,
  onToggle,
  icons = DEV_TOOL_ICONS,
  className = "grid grid-cols-6 sm:grid-cols-8 md:grid-cols-10 gap-2 max-h-52 overflow-y-auto p-2 bg-white/5 border border-navy-border rounded-md",
}) {
  return (
    <div className={className}>
      {icons.map(({ key, label, Icon }) => {
        const active = selected.includes(key);
        return (
          <button
            type="button"
            key={key}
            title={label}
            onClick={() => onToggle(key)}
            className={`flex flex-col items-center justify-center gap-1 p-2 rounded-md border text-[10px] transition-colors ${
              active
                ? "bg-accent/20 border-accent-light text-accent-light"
                : "border-transparent text-gray-400 hover:bg-white/10 hover:text-white"
            }`}
          >
            <Icon size={18} />
            <span className="w-full text-center leading-tight line-clamp-2">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
